export default __webpack_public_path__ + "static/media/BannerSeminario.15b3d959.svg";